import React, { useState, useEffect, useCallback } from 'react'
import './../buttons/styles.scss'
import './styles.scss'
import { useDropzone } from 'react-dropzone'
import arrow from './../../images/upload-ico.svg'
import loading from './../../images/loading-ico.svg'
import info from './../../images/i-ico-blue.svg'
import ModalMessage from '../modal-message/ModalMessage';


const UploadDragDropFiles = ( props ) => {
    let [ loadedApi, setLoadedApi ] = useState(false);
    let [ error, setError ] = useState(false);
    let [ activeModal, setActiveModal ] = useState(false);
    let [ uploadedFileText, setUploadedFileText ] = useState( '' );


    useEffect(() => {
      setError( props.error );
    }, [props.error]);

    useEffect(() => {
      if(props.required && props.forceValidate) {
        validate();
      }
    }, [props.forceValidate])

    useEffect(() => {
      setUploadedFileText( props.buttonText );
    }, [props.buttonText]);
    
    let onDrop = useCallback((acceptedFiles ) => {
        const reader = new FileReader()
        reader.onabort = () => setUploadedFileText('Plik odrzucono')
        reader.onerror = () => setUploadedFileText('Błąd w trakcie wczytywania pliku')
        reader.onprogress = () => setUploadedFileText('Wczytuję plik')
        // reader.onload = () => {
        //   setUploadedFile( true );
        //   setUploadedFileText(`Plik został wgrany poprawnie`);
        // }
        let tempArray = [];
        acceptedFiles.forEach( async file => {
            tempArray = [...tempArray, {file: file, title: props.title}]
        })
        props.setFunction(tempArray);
      }, [])

    let {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})
    
    const validate = () => {
      if(!props?.data && !props?.data?.file) {
        setError(true);
      }else{
        setError(false)
      }
    }
    return (
        <>
          <div className={'upload-wrapper ' + ( error ? 'error error-item' : '') + ( isDragActive ? 'active' : '')} {...getRootProps()}>
            <div className={`icon ${props?.data?.file ? 'success' : ''}`}>
              {!props?.data?.file &&
                <svg width="33" height="30" viewBox="0 0 33 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.07 20.76L8.99 13.15V11.2L15.41 18.11V0H16.74V18.09L23.14 11.21V13.16L16.07 20.76ZM1.33 18.54H0V29.71H29.46V28.38H1.33V18.54ZM30.79 28.33V29.71H32.12V18.55H30.79V28.34V28.33Z" fill="#231F20"/>
                </svg>
              }
              {props?.data?.file &&
                <svg width="33" height="22" viewBox="0 0 33 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.33 20.67H29.46V22H0V10.83H1.33V20.67ZM30.79 20.63V22.01H32.12V10.85H30.79V20.64V20.63ZM12.65 14.62C12.77 14.74 12.93 14.8 13.09 14.8C13.25 14.8 13.41 14.74 13.53 14.62L23.6 4.55L22.73 3.68L13.1 13.31L8.29 8.5L9.6 7.19L12.66 10.25C12.9 10.49 13.29 10.49 13.53 10.25L22.27 1.49L24.46 3.68L25.33 2.81L22.71 0.18C22.47 -0.06 22.08 -0.06 21.84 0.18L13.09 8.93L10.03 5.87C9.79 5.63 9.4 5.63 9.16 5.87L6.97 8.06C6.85 8.18 6.79 8.33 6.79 8.5C6.79 8.67 6.85 8.82 6.97 8.94L12.66 14.63L12.65 14.62Z" fill="#FBB900"/>
                </svg>
              }
            </div>
            <div className="text">
              <p><strong>{props.title}</strong></p>
              <p>{`${props?.data?.file ? props.data.file.name : 'Select or drag & drop file'}`}</p>
            </div>
            <div className="btn-wrap" onClick={() => props?.data?.file && props.remove(props.title)}>
                <div className={"btn upload " +  ( props?.data?.file? 'have ' : '')}>
                    {!props?.data?.file &&
                      <input {...getInputProps()} />
                    }
                    <span>{props?.data?.file ? "Remove" : "Upload"}</span>
                </div>
            </div>
          </div>
        </>
    )
}

export default UploadDragDropFiles;